'use strict';

import * as Onyx from '../../lib/onyx.min.js';

export default class SceneLevelComplete extends Onyx.Scene {
    constructor(){
        super({
            template: '@@import routes/level-complete/index.html',
            clock: new Onyx.Clock()
        });
    }
    
    onload(){
        super.onload();
                    
        document.getElementById("levelup").style.display = "block";
        document.getElementById("levelup").classList.add("tada");
        
        // game.sfx['levelup'].play();

        this.setTimeout(() => {
            document.getElementById("levelup").classList.remove("tada");
            document.getElementById("levelup").classList.add("fadeOutUp");

            this.setTimeout(() => {    
                document.getElementById("levelup").style.display = "none";
                document.getElementById("levelup").classList.remove("fadeOutUp");

                this.modalResult(true);
            }, 1000);
        }, 2000);
    }
}